import { TogglTimeEntry } from '../../../types/toggl-api';

import { Filters } from './components/SearchFilters';

export function filterTimeEntries(
  timeEntries: TogglTimeEntry[],
  filters: Filters
) {
  let results = timeEntries;
  if (filters.search) {
    results = timeEntries.filter((timeEntry) =>
      timeEntry.description.toLowerCase().includes(filters.search.toLowerCase())
    );
  }
  return results;
}

export function formatTimestamp(timestampInSeconds: number) {
  const seconds = Math.floor(timestampInSeconds);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let formattedString = '';
  if (hours > 0) {
    formattedString += `${hours}h `;
  }
  if (minutes > 0 || hours > 0) {
    formattedString += `${minutes}m `;
  }
  formattedString += `${remainingSeconds}s`;

  return formattedString;
}

export function getDate(timestamp: number) {
  const currentDate = new Date(timestamp);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getToday() {
  return getDate(Date.now());
}

export function getThirtyDaysAgo() {
  return getDate(Date.now() - 30 * 24 * 60 * 60 * 1000);
}

export function getOneYearAgo() {
  return getDate(Date.now() - 365 * 24 * 60 * 60 * 1000);
}

export const getTimestamp = (date: string) => new Date(date).getTime();
export const getFormattedDate = (date: string) =>
  new Date(date).toLocaleString('en');

export function getDateMinusDays(date: string, numOfDays: number) {
  return getDate(Date.parse(date) - numOfDays * 24 * 60 * 60 * 1000);
}

export function getDatePlusDays(date: string, numOfDays: number) {
  return getDate(Date.parse(date) + numOfDays * 24 * 60 * 60 * 1000);
}

export function getDisablementReason(
  isTooShort: boolean,
  hasIssueKey: boolean
) {
  if (isTooShort) {
    return 'Time is too short';
  }
  return !hasIssueKey ? 'Issue key missing' : '';
}
